import { ComponentPropsWithoutRef } from "react"
import { cn } from "@/lib/utils"

interface MarqueeProps extends ComponentPropsWithoutRef<"div"> {
  /**
   * Optional CSS class name to apply custom styles
   */
  className?: string
  /**
   * Whether to reverse the animation direction
   * @default false
   */
  reverse?: boolean
  /**
   * Whether to pause the animation on hover
   * @default false
   */
  pauseOnHover?: boolean
  /**
   * Content to be displayed in the marquee
   */
  children: React.ReactNode
  /**
   * Whether to animate vertically instead of horizontally
   * @default false
   */
  vertical?: boolean
  /**
   * Number of times to repeat the content
   * @default 4
   */
  repeat?: number
}

export function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={cn(
        "group flex overflow-hidden w-full",
        vertical ? "flex-col" : "flex-row",
        pauseOnHover ? 'pause-on-hover' : '',
        className
      )}
      style={{
        width: '100%',
        boxSizing: 'border-box',
        gap: '1rem',
        ['--duration' as any]: '40s',
        ['--gap' as any]: '1rem',
      }}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={cn(
              "flex shrink-0 justify-around",
              vertical ? "flex-col animate-marquee-vertical" : "flex-row animate-marquee"
            )}
            style={{
              animationDirection: reverse ? 'reverse' : 'normal',
              gap: '1rem',
              // The animationDuration is set via CSS variable on the container
            }}
          >
            {children}
          </div>
        ))}
    </div>
  )
}